// extracted by mini-css-extract-plugin
module.exports = {"headerColumn":"feedteststyle-module_headerColumn__3ATLPjQpJf9rKflcHf5_nY","rowColumn":"feedteststyle-module_rowColumn__3bOTweJuoQkcM_JtlEkiWp"};